module.exports = __webpack_public_path__ + "img/7.93000f68.png";